import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { WatchlistService } from '../../services/watchlist.service';
import { AuthService } from '../../services/auth.service';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { TranslatePipe } from '../../pipes/translate.pipe';

@Component({
  selector: 'app-watchlist-button',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './watchlist-button.component.html',
  styleUrl: './watchlist-button.component.scss'
})
export class WatchlistButtonComponent implements OnInit, OnDestroy {
  @Input() product: any;
  @Input() productId!: number;
  
  isInWatchlist = false;
  private subscription = new Subscription();

  get isUpdating(): boolean {
    return this.watchlistService.isMutationPending(this.productId);
  }

  constructor(
    private watchlistService: WatchlistService,
    private authService: AuthService,
    private router: Router,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    // Get productId from product object if not provided directly
    if (!this.productId && this.product?.id) {
      this.productId = this.product.id;
    }
    
    if (!this.productId) {
      return;
    }
    
    this.checkWatchlistStatus();
    
    this.subscription.add(
      this.watchlistService.watchlist$.subscribe(() => {
        this.checkWatchlistStatus();
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private checkWatchlistStatus(): void {
    if (!this.authService.isLoggedIn()) {
      this.isInWatchlist = false;
      return;
    }

    this.watchlistService.isInWatchlist(this.productId).subscribe({
      next: (isInWatchlist) => {
        this.isInWatchlist = isInWatchlist;
      },
      error: (error) => {
        this.isInWatchlist = false;
      }
    });
  }

  toggleWatchlist(event: Event): void {
    event.stopPropagation();
    
    if (!this.authService.isLoggedIn()) {
      this.router.navigate(['/auth/login']);
      return;
    }
    if (this.watchlistService.isMutationPending(this.productId)) return;

    if (this.isInWatchlist) {
      this.isInWatchlist = false;
      this.watchlistService.removeFromWatchlist(this.productId).subscribe({
        next: () => {
        },
        error: (error) => {
          this.isInWatchlist = this.watchlistService.containsProduct(this.productId);
          this.toastr.error(error.message || 'Failed to remove from watchlist', 'Error');
        }
      });
    } else {
      this.isInWatchlist = true;
      this.watchlistService.addToWatchlist(this.productId).subscribe({
        next: () => {
        },
        error: (error) => {
          this.isInWatchlist = this.watchlistService.containsProduct(this.productId);
          this.toastr.error(error.message || 'Failed to add to watchlist', 'Error');
        }
      });
    }
  }
}
